import { Toast } from '@whelk/components';
import axios from '@whelk/request/src/services/axios';
import { store } from '@whelk/store';
import { setFilePreview } from '@whelk/store/slices/fileSlice';
import { trackCustomEvent } from '@whelk/utils/src/track';

import type { ApiResp } from './common';

async function fetchAndDecode(url: string, encoding = 'utf-8', fatal = true) {
  const response = await fetch(url);
  const reader = response.body?.getReader();
  const decoder = new TextDecoder(encoding, { fatal });
  const chunks = [];
  let done, value;

  while (!done && reader) {
    ({ done, value } = await reader.read());
    if (value) {
      chunks.push(decoder.decode(value, { stream: true }));
    }
  }
  // 最后一次调用以确保流的结束
  chunks.push(decoder.decode());
  return chunks.join('');
}

export function getTxt(
  url: string,
  trackParams: {
    chat_id: string;
  },
) {
  return new Promise<string>((resolve) => {
    fetchAndDecode(url)
      .then((res) => resolve(res))
      .catch(() => {
        fetchAndDecode(url, 'gbk')
          .then((res) => resolve(res))
          .catch(() => {
            Toast.show('文件解码失败');
            const { chat_id } = trackParams;
            trackCustomEvent({
              id: 'file_preview_click',
              chat_id,
              preview_status: 'fail',
              file_type: 'txt',
            });
            store.dispatch(
              setFilePreview({
                url: '',
                name: '',
              }),
            );
          });
      });
  });
}

export const getLocalPdfUrl = async (url: string) => {
  const res = await fetch(url);
  const blob = await res.blob();
  return URL.createObjectURL(blob);
};

export async function getFileByFileId(fileID: string) {
  const url = `/v1/api/chat/file/${fileID}`;
  const { data: resp } = await axios.get<ApiResp<any>>(url);
  return resp.data;
}
